import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ParametreDto } from "../../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ObjectParsingInstance } from "../../Controls/ObjectParsing";

@Component
export default class ModalParamVariablesPst extends Vue {
	public listeRubrique: ParametreDto[] = [];

	public Init(): void {
    	ServicesFactoryInstance.VariablesService.getVariables("", data => {
    		this.listeRubrique = ObjectParsingInstance.removeDuplicateByUniqueKey(data.filter(d => d.EstVisiblePst), "Id");
    	});
	}

	public annuler(): void {
    	$("#modalParamVariablesPst").modal("hide");
    	this.Init();
	}

	public enregistrer(): void {
    	ServicesFactoryInstance.VariablesService.updateVariables(this.listeRubrique, () => {
    		this.$emit("updateCompleted");
    	});
    	this.annuler();
	}
}



// WEBPACK FOOTER //
// ./src/components/saisieDesVariables/modalParamVariablesPst/modalParamVariablesPst.ts